// extracted by mini-css-extract-plugin
module.exports = {"main":"home-page_main__3G4-L"};